import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { Id } from 'src/app/models/database/types/id.model';
import { PageTabs } from 'src/app/models/utils/components/page-tab.model';
import { RouterClass } from 'src/app/services/utils/router/router-class.routes';

@Injectable({
  providedIn: 'root'
})
export class PepControllerService {

  selectedDatasheetIdSubject: BehaviorSubject<number> = new BehaviorSubject<number>(null)
  selectedDatasheetId$: Observable<number> = this.selectedDatasheetIdSubject.pipe(
    filter(id => id !== null)
  )
  datasheetDeleted: BehaviorSubject<void> = new BehaviorSubject<void>(null)
  datasheetsSubject: BehaviorSubject<void> = new BehaviorSubject<void>(null)

  get pageTabs(): PageTabs {
    const pepRouters = RouterClass.routerLinks.datasheets
    return [
      { routerLink: pepRouters.PREVIEW, label: 'Preview' }
    ]
  }

  refresh(): void {
    this.datasheetsSubject.next(this.datasheetsSubject.value)
  }

  refreshSelectedDatasheet(): void {
    this.selectedDatasheetIdSubject.next(this.selectedDatasheetIdSubject.value)
  }
}